import * as angular from 'angular';

import { ComponentDefinition } from '../../models';
import { IWideDatabaseService, IStatusService, ILoggerService, ISignalrService } from '../../services';

class ConnectionPointActionsController implements angular.IComponentController, angular.IOnInit {
    isLoading: boolean;
    loadingMessage: string;
    isUpdatingDatabase: boolean;
    updateDatabasePercent: number;
    updateInputValuesStatusesPercent: number;
    updateCalculatedValuesStatusesPercent: number;
    isConnectedToHub: boolean;

    static $inject = [
        '$scope',
        'wideDatabaseService',
        'statusService',
        'loggerService',
        'signalrService'
    ];

    constructor(
        private _$scope: angular.IScope,
        private _wideDatabaseService: IWideDatabaseService,
        private _statusService: IStatusService,
        private _loggerService: ILoggerService,
        private _signalrService: ISignalrService) {
    }

    $onInit() {
        this.updateDatabasePercent = 0;
        this.updateInputValuesStatusesPercent = 0;
        this.updateCalculatedValuesStatusesPercent = 0;
        this.isConnectedToHub = true;

        this.initializeSignalr();
    }

    canUpdate(): boolean {
        return !this.isConnectedToHub || this.isLoading;
    }

    updateDatabase(): void {
        this.isLoading = true;
        this.isUpdatingDatabase = true;
        this.updateDatabasePercent = 0;

        this._signalrService.disconnect();
        this._signalrService.connect(this._updateDatabase());
    }

    private _updateDatabase() {
        const self = this;
        return () => self._wideDatabaseService.migrateDatabaseAsync()
            .then((data: string) => {
                self._loggerService.log(data, true);
                self.isLoading = false;
            })
            .finally(() => self.isUpdatingDatabase = false);
    }

    updateInputValuesStatuses(): void {
        this.isLoading = true;
        this.updateInputValuesStatusesPercent = 0;

        this._signalrService.disconnect();
        this._signalrService.connect(this._updateInputValuesStatuses());
    }

    private _updateInputValuesStatuses() {
        const self = this;
        return () => self._statusService.updateStatusInputValuesAsync()
            .then((data: number) => {
                if (data >= 0) {
                    self._loggerService.logSuccess('Status of InputValues succesfully upgraded.', true);
                } else {
                    self._loggerService.logError('An error occured during upgrade of InputValues status.', true);
                }
                this.isLoading = false;
            });
    }

    private initializeSignalr(): void {
        const self = this;

        const progressHubProxy = this._signalrService.connection.createHubProxy('progressHub');

        progressHubProxy.on('updateProgressBarUpdateDatabase', (percent: number) => {
            self.updateDatabasePercent = percent;
            self._$scope.$digest();
        });

        progressHubProxy.on('updateProgressBarUpdateInputValuesStatuses', (percent: number) => {
            self.updateInputValuesStatusesPercent = percent;
            self._$scope.$digest();
        });

        progressHubProxy.on('updateProgressBarUpdateCalculatedValuesStatuses', (percent: number) => {
            self.updateCalculatedValuesStatusesPercent = percent;
            self._$scope.$digest();
        });

        this._signalrService.connect(() => { self.isConnectedToHub = true; });
    }
}

export const wtConnectionPointActions: ComponentDefinition = {
    componentId: 'wtConnectionPointActions',
    controller: ConnectionPointActionsController,
    template: require('./connectionPointActions.component.html'),
    controllerAs: 'vm',
    bindings: {

    }
};
